import { render, staticRenderFns } from "./LightCourseConstructor.vue?vue&type=template&id=b6a601ec&scoped=true&"
import script from "./LightCourseConstructor.vue?vue&type=script&lang=js&"
export * from "./LightCourseConstructor.vue?vue&type=script&lang=js&"
import style0 from "./LightCourseConstructor.vue?vue&type=style&index=0&id=b6a601ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a601ec",
  null
  
)

export default component.exports